import {
  CREATE_COMMITMENT,
  CREATE_COMMITMENT_FAILED,
  CREATE_COMMITMENT_SUCCESS,

  CREATE_COMMITMENT_ACTIVITY,
  CREATE_COMMITMENT_ACTIVITY_COMPLETE,

  FETCH_COMMITMENTS,
  FETCH_COMMITMENTS_COMPLETE,
  FETCH_SINGLE_COMMITMENT,
  FETCH_SINGLE_COMMITMENT_COMPLETE,

} from './types';
import { toast } from 'react-toastify';
import { updateCommitmentService, deleteCommitmentService, createCommitmentService, createCommitmentActivityService, fetchCommitmentService, fetchSingleCommitmentService, updateCommitmentActivityService, deleteCommitmentActivityService } from './api';
import uploadFile from '../../utils/uploadFile';


export const fetchCommitmentAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_COMMITMENTS });
    const response = await fetchCommitmentService(params)();
    dispatch({
      type: FETCH_COMMITMENTS_COMPLETE,
      payload: response?.data,
    });
  } catch (error) {
    dispatch({ type: FETCH_COMMITMENTS_COMPLETE, payload: [] });
  }
};


export const fetchSingleCommitmentAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_SINGLE_COMMITMENT });
    const response = await fetchSingleCommitmentService(id)();
    dispatch({
      type: FETCH_SINGLE_COMMITMENT_COMPLETE,
      payload: response?.data,
    });
  } catch (error) {
    dispatch({ type: FETCH_SINGLE_COMMITMENT_COMPLETE, payload: null });
  }
};


export const deleteCommitmentAction =
  ({ token, params }) =>
    async () => {
      try {
        await deleteCommitmentService(token, params)();
        toast.success("Commitment Deleted. Please reload page");

        return true;
      } catch (error) {
        toast.error("Commitment could not be deleted");
      }
    };


export const updateCommitmentActivityAction =
  ({ token, params, id }) =>
    async (dispatch) => {
      try {
        dispatch({ type: CREATE_COMMITMENT_ACTIVITY });
        let secure_url = params.icon;
        if (typeof params.icon !== 'string') {
          const uploadRes = await uploadFile(params.icon);
          secure_url = uploadRes.secure_url;
        }
        await updateCommitmentActivityService(token, id)({
          ...params,
          icon: secure_url,
        });
        dispatch({ type: CREATE_COMMITMENT_ACTIVITY_COMPLETE });
        toast.success('Activity Updated Successfully')
        return true;
      } catch (error) {
        dispatch({ type: CREATE_COMMITMENT_ACTIVITY_COMPLETE });
        toast.error('Activity could not be updated')
      }
    };

export const deleteCommitmentActivityAction =
  ({ token, id }) =>
    async (dispatch) => {
      try {
        await deleteCommitmentActivityService(token, id)();
        toast.success('Activity Deleted Successfully')
        return true;
      } catch (error) {
        toast.error('Activity could not be deleted')
      }
    };

export const updateCommitmentAction = ({ token, params }) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_COMMITMENT })
    await updateCommitmentService(token, params.id)(params);
    dispatch({ type: CREATE_COMMITMENT_SUCCESS });
    toast.success('Commitment updated Successfully')
    return true;
  } catch (error) {
    dispatch({ type: CREATE_COMMITMENT_FAILED });
    toast.error('Commitment could not be updated')
  }
}

export const createCommitmentAction = ({ token, params }) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_COMMITMENT })
    await createCommitmentService(token)(params);
    dispatch({ type: CREATE_COMMITMENT_SUCCESS });
    toast.success('Commitment Created Successfully')
    return true;
  } catch (error) {
    dispatch({ type: CREATE_COMMITMENT_FAILED });
    toast.error('Commitment could not be added')
  }
}

export const createCommitmentActivityAction =
  ({ token, params }) =>
    async (dispatch) => {
      try {
        dispatch({ type: CREATE_COMMITMENT_ACTIVITY });
        const { secure_url } = await uploadFile(params.icon);
        const response = await createCommitmentActivityService(token)({
          ...params,
          icon: secure_url,
          description: params.description || params.name,
        });
        dispatch({ type: CREATE_COMMITMENT_ACTIVITY_COMPLETE });
        toast.success('Activity Created Successfully')
        return !!response;
      } catch (error) {
        dispatch({ type: CREATE_COMMITMENT_ACTIVITY_COMPLETE });
        toast.error('Activity could not be added')

      }
    };